import React from "react";
import { AccountTreeOutlined, Check, KeyboardArrowRight } from "@mui/icons-material";
import { Alert, Box, Button, Typography } from "@mui/material";
import {
  PIF_IDENTITY_ROUTES,
  PifIdentityFlow,
} from "./workflowRunData";

interface WorkflowPifRouteStageProps {
  flow: Exclude<PifIdentityFlow, "blocked">;
  onContinue: () => void;
}

const WorkflowPifRouteStage: React.FC<WorkflowPifRouteStageProps> = ({
  flow,
  onContinue,
}) => (
  <>
    <Alert
      severity="info"
      icon={<AccountTreeOutlined />}
      className="workflow-run__alert workflow-run__alert--flush"
    >
      The engine evaluated the identity lookup and selected a route automatically.{" "}
      <strong>First match wins.</strong>
    </Alert>

    <Box
      component="ol"
      className="workflow-run__routes"
      aria-label="Identity routing result"
    >
      {PIF_IDENTITY_ROUTES.map((route, index) => {
        const selected = route.flow === flow;

        return (
          <Box
            component="li"
            key={route.flow}
            className={`workflow-run__route${selected ? " workflow-run__route--selected" : ""}`}
            aria-current={selected ? "step" : undefined}
          >
            <span className="workflow-run__route-marker" aria-hidden="true">
              {/* Prototype uses its `branch` glyph here — the stage type's own icon stays in the
                  orange header. AccountTree is the closest stock MUI equivalent. */}
              {selected ? <Check /> : <AccountTreeOutlined />}
            </span>
            <Box className="workflow-run__route-copy">
              <Typography className="workflow-run__route-name">
                {route.label}
              </Typography>
              <Typography className="workflow-run__route-state">
                {selected ? "Selected route" : `Rule ${index + 1} · Not matched`}
              </Typography>
            </Box>
            {selected && <span className="workflow-run__routed-pill">Routed</span>}
          </Box>
        );
      })}
    </Box>

    <Box className="workflow-run__actions workflow-run__actions--end">
      <Button
        variant="contained"
        endIcon={<KeyboardArrowRight />}
        onClick={onContinue}
      >
        Continue
      </Button>
    </Box>
  </>
);

export default WorkflowPifRouteStage;
